// « Ajoute une photo de profil » — shown ONCE on Home to members still on the default avatar
// (server stamp users.avatar_nudge_seen_at makes it never come back, on any device).
// Jamais pendant que la carte « Complète ton profil » est affichée (elle propose déjà la photo) — lot 589.
import { profileCompletionCardVisible } from "@/lib/profileDone";

export const shouldNudgeAvatar = (user) =>
  !!user && !user.is_bot && !user.is_church && !(user.avatar_url || "").trim() && !user.avatar_nudge_seen_at && !profileCompletionCardVisible(user);
